import React from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardBody, Col,
} from 'reactstrap';
import ReactTableBase from 'src/shared/components/table/ReactTableBase';
import { useTranslation } from 'react-i18next';

const RiderLocationHistoryDetails = ({ reactTableData, isNoRecordFound }) => {
  const { t } = useTranslation('common');

  const tableConfig = {
    isEditable: false,
    isSortable: true,
    isResizable: true,
    withPagination: true,
    withSearchEngine: true,
    manualPageSize: [10, 50, 100, 1000],
    placeholder: 'Search by Rider Name ...',
  };

  const tableRowsData = reactTableData?.tableRowsData || [];
  const tableHeaderData = reactTableData?.tableHeaderData || [];

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          {!isNoRecordFound && tableRowsData.length > 0 &&
            <ReactTableBase
              name={t('instution_type.view.name_map')}
              key={'searchable'}
              columns={tableHeaderData}
              data={tableRowsData}
              tableConfig={tableConfig}
            />
          }
          {isNoRecordFound && <h3 className="page-title">No Record Found</h3>}
        </CardBody>
      </Card>
    </Col>
  );
};

RiderLocationHistoryDetails.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }),
  isNoRecordFound: PropTypes.bool,
};

RiderLocationHistoryDetails.defaultProps = {
  reactTableData: null,
  isNoRecordFound: false,
};

export default RiderLocationHistoryDetails;
